var map = {
	"./Screenshot_20260613-131551.png": 937,
	"./Screenshot_20260613-131614.png": 915,
	"./Screenshot_20260613-131626.png": 120,
	"./Screenshot_20260613-131637.png": 446,
	"./Screenshot_20260613-131650.png": 187,
	"./Screenshot_20260613-131659.png": 258,
	"./Screenshot_20260613-131707.png": 722,
	"./Screenshot_20260613-131718.png": 970,
	"./Screenshot_20260613-131726.png": 957,
	"./Screenshot_20260613-131745.png": 479,
	"./Screenshot_20260613-131800.png": 530,
	"./Screenshot_20260613-131808.png": 250,
	"./Screenshot_20260613-131816.png": 147,
	"./Screenshot_20260613-131834.png": 399,
	"./Screenshot_20260613-131842.png": 732,
	"./Screenshot_20260613-135636.png": 651,
	"./Screenshot_20260613-135645.png": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;